import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-sidenav-bar',
  templateUrl: './sidenav-bar.component.html',
  styleUrls: ['./sidenav-bar.component.scss']
})
export class SidenavBarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
